import React, { useEffect, useState } from "react";
import "./index.less";
import {
  hot,
  hot_w,
  pen,
  pen_w,
  topic,
  topic_w,
  play,
} from "@/assets/Inspiration-center";
import {
  Input,
  Pagination,
  Select,
  Spin,
  Table,
  Tooltip,
} from "@arco-design/web-react";

import Collapse from "@/components/UI/Collapse/ectype";
import LabelSwitching from "@/components/business/LabelSwitching/ectype";
import { useNavigate } from "react-router-dom";
import { getNewHotSpot } from "@/services/creativeScript/explosiveScript";
import useData from "./useData";
import { IconLeft, IconRight, IconSearch } from "@arco-design/web-react/icon";
import dayjs from "dayjs";
import { empty_icon } from "@/assets/workbenchimage";
import useNavigateTo from "@/utils/useNavigateTo";
import appStore from "@/stores/appStore";

const Option = Select.Option;
function HotListOverview() {
  const { navigateTo } = useNavigateTo();
  const [tagActiveIndex, setTagActiveIndex] = useState(3);
  const [isShowCollapse, setIsShowCollapse] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [tagLoading, setTagLoading] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigat = useNavigate();
  const [pageSize, setPageSize] = useState<number>(0);
  const {
    hotspotVideoList,
    hotspotVideoLoading,
    hotspotVideoSearch,
    setHotspotVideoSearch,

    hotspotTopicList,
    hotspotTopicLoading,
    hotspotTopicSearch,
    setHotspotTopicSearch,

    hotspotSentenceList,
    hotspotSentenceLoading,
    hotspotSentenceSearch,
    setHotspotSentenceSearch,

    getColumns,
    timeOptions,
    heightOptions,
    expandedRowKeys,
    expandRow,
    isAtLeft,
    isAtRight,
    handleMouseDown,
    handleMouseUpOrLeave,
    contentWrapperRef,
    hotspotSentenceTotal,
    hotspotTopicTotal,
    handleMouseMove,
    handleMouseDownDrag,
    timeDifference,
  } = useData(tagActiveIndex);

  const handleClickActive = (index) => {
    setIsShowCollapse([]);
    setTagActiveIndex(index);
  };
  function restructureArray(arr) {
    // 先创建一个空的对象，用来存储所有的id和对应的数据
    const map = {};

    // 遍历数组，将每个元素的id和元素本身存储到map中
    arr.forEach((item) => {
      map[item.id] = { ...item, children: [] };
    });

    // 再次遍历数组，将子级元素放入父级的children数组中
    arr.forEach((item) => {
      if (item.parent_id) {
        map[item.parent_id].children.push(map[item.id]);
      }
    });

    // 过滤出没有parent_id的项（即根节点）
    return arr.filter((item) => !item.parent_id).map((item) => map[item.id]);
  }

  const handleGetNewHotSpot = async (type) => {
    setTagLoading(true);
    const res = await getNewHotSpot({ type });
    setTagLoading(false);

    if (res?.code == 0 && res.data.items) {
      const arr: any = [
        {
          title: "行业",
          checkAll: false,
          children: [
            {
              label: "全部",
              value: "全部",
              checked: true,
            },
          ].concat(restructureArray(res.data.items)),
        },
      ];
      if (tagActiveIndex == 3) {
        arr.push(
          {
            title: "类型",
            checkAll: false,
            children: [
              {
                label: "播放最高",
                value: 1,
                checked: true,
                id: 1,
              },
              {
                label: "点赞最多",
                value: 2,
                checked: false,
                id: 2,
              },
              {
                label: "评论最多",
                value: 3,
                checked: false,
                id: 3,
              },
              {
                label: "热度最高",
                value: 4,
                checked: false,
                id: 4,
              },
            ],
          },
          {
            title: "时间",
            checkAll: false,
            children: [
              {
                label: "30天",
                value: 3,
                checked: true,
                id: 1,
              },
              {
                label: "7天",
                value: 2,
                checked: false,
                id: 2,
              },
              {
                label: "24小时",
                value: 1,
                checked: false,
                id: 3,
              },
            ],
          }
        );
      }
      if (tagActiveIndex == 2) {
        arr.push({
          title: "时间",
          checkAll: false,
          children: [
            {
              label: "近30天",
              value: dayjs().subtract(30, "day").format("YYYYMMDD"),
              checked: true,
              id: 5,
            },
            {
              label: "近7天",
              value: dayjs().subtract(7, "day").format("YYYYMMDD"),
              checked: false,
              id: 4,
            },
            {
              label: "近3天",
              value: dayjs().subtract(3, "day").format("YYYYMMDD"),
              checked: false,
              id: 3,
            },
            {
              label: "近1天",
              value: dayjs().subtract(1, "day").format("YYYYMMDD"),
              checked: false,
              id: 2,
            },
            {
              label: "近1小时",
              value: dayjs().subtract(1, "hour").format("YYYYMMDDHHmmss"),
              checked: false,
              id: 1,
            },
          ],
        });
      }
      if (tagActiveIndex == 1) {
        arr.push(
          {
            title: "类型",
            checkAll: false,
            children: [
              {
                label: "话题总榜",
                value: 2001,
                checked: true,
                id: 1,
              },
              {
                label: "热度播飙升的话题榜",
                value: 2002,
                checked: false,
                id: 2,
              },
            ],
          },
          {
            title: "时间",
            checkAll: false,
            children: [
              {
                label: "近7天",
                value: 168,
                checked: true,
                id: 4,
              },
              {
                label: "近3天",
                value: 72,
                checked: false,
                id: 3,
              },
              {
                label: "近1天",
                value: 24,
                checked: false,
                id: 2,
              },
              {
                label: "近1小时",
                value: 1,
                checked: false,
                id: 1,
              },
            ],
          }
        );
      }
      setTagList(arr);
    }
  };
  useEffect(() => {
    handleGetNewHotSpot(tagActiveIndex);
    setPageSize(
      tagActiveIndex == 1
        ? hotspotTopicSearch.page_size
        : hotspotSentenceSearch.page_size
    );
  }, [tagActiveIndex]);
  useEffect(() => {
    setData(hotspotVideoList || hotspotTopicList || hotspotSentenceList || []);
  }, [hotspotVideoList, hotspotTopicList, hotspotSentenceList]);

  useEffect(() => {
    setLoading(
      hotspotVideoLoading || hotspotTopicLoading || hotspotSentenceLoading
    );
  }, [hotspotVideoLoading, hotspotTopicLoading, hotspotSentenceLoading]);

  useEffect(() => {
    setTotal(hotspotSentenceTotal || hotspotTopicTotal);
  }, [hotspotSentenceTotal, hotspotTopicTotal]);

  const expandedRowRender = (record) => {
    return (
      <div className="expanded-row">
        <p>相关视频（{expandRow.length}）</p>
        <div
          className={`scroll-left ${isAtLeft ? "hidden" : ""}`}
          onMouseDown={() => handleMouseDown(-1)}
          onMouseUp={handleMouseUpOrLeave}
          onMouseLeave={handleMouseUpOrLeave}
        >
          <IconLeft fontSize={20} />
        </div>
        <div
          className="content-wrapper"
          ref={contentWrapperRef}
          onMouseMove={handleMouseMove}
          onMouseDown={handleMouseDownDrag}
          onMouseUp={handleMouseUpOrLeave}
          onMouseLeave={handleMouseUpOrLeave}
        >
          <div className="images-box">
            {expandRow.length ? (
              expandRow.map((v, index) => (
                <div key={index} className="content">
                  <div
                    className="icon-ai"
                    onClick={(e) => {
                      if (timeDifference > 300) {
                        e.preventDefault();
                        return;
                      }
                      navigat(`/analysis-video`, { state: v.share_url });
                    }}
                  >
                    AI
                  </div>
                  <img width={64} height={83} src={v.item_cover_url} alt="" />
                  <img
                    src={play}
                    width={32}
                    className="play"
                    alt=""
                    onClick={(e) => {
                      if (timeDifference > 300) {
                        e.preventDefault();
                        return;
                      }
                      window.open(v.share_url, "_blank");
                      // navigateTo(v.share_url);
                    }}
                  />
                </div>
              ))
            ) : (
              <div className="empty-box">
                <img src={empty_icon} width={82} alt="" />
                <p>暂无数据</p>
              </div>
            )}
          </div>
        </div>
        <div
          className={`scroll-right ${isAtRight ? "hidden" : ""}`}
          onMouseDown={() => handleMouseDown(1)}
          onMouseUp={handleMouseUpOrLeave}
          onMouseLeave={handleMouseUpOrLeave}
        >
          <IconRight fontSize={20} />
        </div>
      </div>
    );
  };

  return (
    <div className="hot-overview-root">
      <div className="hot-header">
        <div
          className={`hot-video-tag ${tagActiveIndex == 3 ? "hot-active" : ""}`}
          onClick={() => handleClickActive(3)}
        >
          <img width={28} src={tagActiveIndex == 3 ? hot_w : hot} alt="" />
          <p>热门视频</p>
        </div>
        {!appStore.isOdm && (
          <>
            <div
              className={`hotspot-tag ${tagActiveIndex == 2 ? "hotspot-active" : ""}`}
              onClick={() => handleClickActive(2)}
            >
              <img width={28} src={tagActiveIndex == 2 ? pen_w : pen} alt="" />
              <p>创作热点</p>
            </div>
            <div
              className={`topic-tag ${tagActiveIndex == 1 ? "topic-active" : ""}`}
              onClick={() => handleClickActive(1)}
            >
              <img
                width={28}
                src={tagActiveIndex == 1 ? topic_w : topic}
                alt=""
              />
              <p>热门话题</p>
            </div>
          </>
        )}
      </div>
      <div className="hot-tag-box">
        <Collapse isShow={isShowCollapse} hiddenHeight={55} width={"95%"}>
          <LabelSwitching
            tagList={tagList}
            renderProps={(opt) => {
              //
            }}
            isLoading={tagLoading}
            checkRenderProps={(arr: any) => {
              if (!arr.length) {
                return;
              }

              switch (tagActiveIndex) {
                case 3:
                  hotspotVideoSearch.billboard_tag =
                    Number(arr[0].content[0]?.value) || undefined;
                  hotspotVideoSearch.order_key =
                    Number(arr[1].content[0]?.value) || 1;
                  hotspotVideoSearch.time_filter =
                    Number(arr[2].content[0]?.value) || 3;
                  setHotspotVideoSearch({ ...hotspotVideoSearch });
                  break;
                case 2:
                  hotspotSentenceSearch.sentence_tag =
                    arr[0].content[0]?.value || undefined;
                  if (arr[1].content[0]?.id && arr[1].content[0]?.id == 1) {
                    hotspotSentenceSearch.start_date = Number(
                      arr[1].content[0]?.value
                    );
                    hotspotSentenceSearch.type = "snapshot";
                  } else {
                    hotspotSentenceSearch.start_date = Number(
                      arr[1].content[0]?.value
                    );
                    hotspotSentenceSearch.type = "range";
                  }
                  hotspotSentenceSearch.page = 1;
                  setHotspotSentenceSearch({ ...hotspotSentenceSearch });
                  break;
                case 1:
                  hotspotTopicSearch.tags =
                    arr[0].content.map((item) => ({
                      value: Number(item.value),
                      children: item.children.length
                        ? item.children.map((v) => ({
                            value: Number(v.value),
                          }))
                        : undefined,
                    })) || [];
                  hotspotTopicSearch.sub_type = arr[1]?.content[0]?.value;
                  hotspotTopicSearch.date_window = arr[2]?.content[0]?.value;
                  hotspotTopicSearch.page = 1;
                  setHotspotTopicSearch({ ...hotspotTopicSearch });
                  break;
                default:
                  break;
              }
            }}
          />
        </Collapse>
      </div>
      <Spin loading={loading}>
        <div className="hot-table">
          <Table
            border={false}
            virtualized
            scroll={{
              x: 1750,
              y: tagActiveIndex == 3 ? 610 : 570,
            }}
            columns={getColumns()}
            data={data}
            expandedRowRender={(e) => {
              if (tagActiveIndex === 2) {
                return expandedRowRender(e);
              }
              return null;
            }} // 定义展开行渲染的内容
            pagination={false}
            expandProps={{
              expandRowByClick: false,
              icon: ({ record }) => {
                return <div style={{ display: "none" }}></div>;
              },
            }}
            rowKey="sort"
            expandedRowKeys={expandedRowKeys} // 控制展开的行
          />
        </div>
      </Spin>

      {total && total > pageSize ? (
        <Pagination
          showTotal={(total) => `共 ${total}条`} //是否显示数据总数
          total={total} // 数据总数
          current={
            tagActiveIndex == 1
              ? hotspotTopicSearch.page
              : hotspotSentenceSearch.page
          }
          // hideOnSinglePage  // 是否在一页的时候 隐藏
          // sizeCanChange //	是否可以改变每页条数
          onChange={(current, pageSize) => {
            switch (tagActiveIndex) {
              case 2:
                hotspotSentenceSearch.page = current;
                hotspotSentenceSearch.page_size = pageSize;
                setHotspotSentenceSearch({ ...hotspotSentenceSearch });
                break;

              case 1:
                hotspotTopicSearch.page = current;
                hotspotTopicSearch.page_size = pageSize;
                setHotspotTopicSearch({ ...hotspotTopicSearch });
                break;
              default:
                break;
            }
          }}
          className={"tab-pages"}
          style={{ display: tagActiveIndex !== 3 ? "flex" : "none" }}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default HotListOverview;
